module.exports = "/assets/a22e10031283cfc4029f18a5f6546d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/DY.png
// module id = 2445
// module chunks = 0